// src/pages/SingleListingGenerator/constants.js
// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Listing Generator Constants
export const MAX_IMAGES = 5;
export const MAX_APP_IMAGES = 1;
export const TEMPLATE_COUNT = 25;
export const MAX_VARIATIONS = 3;
export const SINGLE_GEN_COST = 50;
export const PRODUCT_COPY_COST = 20;
export const MAX_BULLETS = 10;

// Configuration for theme images
export const THEME_CONFIG = {
    theme1: { bplus: [1, 2, 3, 4, 5, 6], zoomshot: 7, aplus: [7, 8, 9, 10, 11] },
    theme2: { bplus: [1, 2, 3, 4, 5, 6], aplus: [7, 8, 9, 10, 11] },
    theme3: { bplus: [1, 2, 3, 4, 5, 6], aplus: [7, 8, 9, 10] },
    theme4: { bplus: [1, 2, 3, 4, 5, 6], aplus: [7, 8, 9, 10, 11] },
    theme5: { bplus: [1, 2, 3, 4, 5, 6], aplus: [7, 8, 9, 10] },
    theme6: { bplus: [1, 2, 3, 4, 5, 6], aplus: [7, 8, 9, 10,11] },
    theme7: { bplus: [1, 2, 3, 4, 5, 6], aplus: [7, 8, 9, 10, 11] },
    theme8: { bplus: [1, 2, 3, 4, 5, 6], aplus: [7, 8, 9, 10,11] },
    theme9: { bplus: [2, 3, 4, 5, 6, 7], aplus: [9, 10, 11, 12, 13] },
    theme10: { bplus: [2, 3, 4, 5, 6, 7], aplus: [9, 10, 11, 12, 13] },
    theme11: { bplus: [1, 2, 3, 4, 5, 6], aplus: [8, 9, 10, 12] },
    theme12: { bplus: [1, 2, 3, 4, 5, 6], aplus: [8, 9, 10, 11] },
    theme13: { bplus: [1, 2, 3, 4, 5, 6], aplus: [7, 8, 9, 10] },
    theme21: { bplus: [1, 2, 3, 4, 5, 6], aplus: [7, 8, 9, 10, 11] },
    //theme 14 to theme 20
    theme14: { bplus: [1, 2, 3, 4, 5, 7], aplus: [8, 9, 10, 11] },
    theme15: { bplus: [1, 2, 3, 4, 5, 7], aplus: [8, 9, 10, 11] },
    theme16: { bplus: [1, 2, 3, 4, 5, 7], aplus: [8, 9, 10, 11] },
    theme17: { bplus: [1, 2, 3, 4, 5, 7], aplus: [8, 9, 10, 11] },
    theme18: { bplus: [1, 2, 3, 4, 5, 7], aplus: [8, 9, 10, 11, 12] },
    theme19: { bplus: [1, 2, 3, 4, 5, 7], aplus: [8, 9, 10, 11, 12] },
    theme20: { bplus: [1, 2, 3, 4, 5, 7], aplus: [8, 9, 10, 11, 12] },
    theme22: {bplus:[1, 2, 3, 4, 5, 6], aplus: [8, 9, 10, 11, 12]},
    theme23: {bplus:[1, 2, 3, 4, 5, 6], aplus: [8, 9, 10, 11, 12]},
    theme24: {bplus:[1, 2, 3, 4, 5, 6], aplus: [7, 8, 9, 10, 11]},
    theme25: {bplus:[1, 2, 3, 4, 5, 6], aplus: [7, 8, 9, 10, 11]},
    theme28:{bplus:[1, 2, 3, 4, 5, 6], aplus: [7, 8, 9, 10, 11]},
    theme29:{bplus:[1, 2, 3, 4, 5, 6], aplus: [7, 8, 9, 10, 11]},
    theme30:{bplus:[1, 2, 3, 4, 5, 6], aplus: [7, 8, 9, 10, 11]},
    theme31:{bplus:[1, 2, 3, 4, 5, 6], aplus: [7, 8, 9, 10, 11]},
    theme32:{bplus:[1, 2, 3, 4, 5, 6, 7], aplus: [8, 9, 10, 11, 12]},
};

// Configuration for A+ pages that don't need images
export const APLUS_NO_IMAGE_CONFIG = {
    theme1: { 0: true, 1: false, 2: true, 3: true, 4: true },
    theme2: { 0: true, 1: false, 2: true, 3: false, 4: true },
    theme3: { 0: true, 1: true, 2: true, 3: false },
    theme4: { 0: true, 1: true, 2: true, 3: false, 4: false },
    theme5: { 0: true, 1: true, 2: true, 3: false },
    theme6: { 0: true, 1: true, 2: true, 3: true, 4: false },
    theme7: { 0: true, 1: true, 2: true, 3: true, 4: false },
    theme8: { 0: true, 1: true, 2: false, 3: false, 4: true },
    theme9: { 0: true, 1: true, 2: true, 3: true, 4: false },
    theme10: { 0: true, 1: true, 2: true, 3: true, 4: false },
    theme11: { 0: true, 1: true, 2: true, 3: false },
    theme12: { 0: true, 1: true, 2: true , 3: false},
    theme13: { 0: true, 1: true, 2: true, 3: false },
    theme21: { 0: true, 1: true, 2: true, 3: true, 4: false },

    theme14: {0: true, 1: true, 2: false, 3: true },
    theme15: { 0: true, 1: true, 2: false, 3: true , 4:false},
    theme16: { 0: true, 1: true, 2: true, 3: false },
    theme17: { 0: true, 1: true, 2: true, 3: false },
    theme18: { 0: true, 1: true, 2: true, 3: false, 4: true},
    theme19: { 0: true, 1: true, 2: true, 3: true, 4: false },
    theme20: { 0: true, 1: true, 2: true, 3: true, 4: false },

    theme22:{ 0: true, 1: true, 2: true, 3: false, 4: false},
    theme23:{ 0: true, 1: true, 2: true, 3: false, 4: true},
    theme24:{ 0: true, 1: true, 2: true, 3: false, 4: true},
    theme25:{ 0:true, 1:true, 2:true, 3:false, 4:true},

    theme28:{ 0: true, 1: true, 2: true, 3: false, 4: true},
    theme29:{ 0: true, 1: true, 2: true, 3: false, 4: true},
    theme30:{ 0: true, 1: true, 2: false, 3: true, 4: false},
    theme31:{ 0: true, 1: true, 2: false, 3: true, 4: false},
    theme32:{ 0: false, 1: true, 2: true, 3: true, 4: true},

};

// A+ pages whose layout is filled primarily by application_images (the dedicated
// application upload), not the product images. Treated as "no image" pages in
// the upload UI so users aren't prompted to assign a product image. Pages that
// use application_images as a background but still render data.images as the
// main product image are NOT listed here — they still need a product image.
// Indexes are 0-based.
export const APLUS_APPLICATION_IMAGE_PAGES = {
    theme1: [],
    theme2: [],
    theme3: [3],
    theme4: [3],
    theme5: [3],
    theme6: [4],
    theme7: [4],
    theme8: [3],
    theme9: [2],
    theme10: [3],
    theme11: [3],
    theme12: [3],
    theme13: [1, 4],
    theme14: [2, 3],
    theme15: [2, 4],
    theme16: [3, 4],
    theme17: [3, 4],
    theme18: [3],
    theme19: [4],
    theme20: [4],
    theme21: [4],
    theme22: [3],
    theme23: [3],
    theme24: [3],
    theme25: [3],
    theme26: [4],
    theme28: [3],
    theme29: [3],
    theme30: [4],
    theme31: [4],
    theme33: [4],
    theme34: [1],
    theme37: [3],
    theme38: [2],
    theme40: [3, 4],
    theme41: [3, 4],
    theme42: [3, 4],
    theme43: [4],
    theme44: [4],
    theme45: [3, 4],
    theme46: [3, 4],
    theme47: [3, 4],
};

// Returns true if the A+ page at `index` for `themeId` requires a product image.
// Pages flagged false in APLUS_NO_IMAGE_CONFIG, or that consume application_images,
// don't need a product image.
export const aplusPageNeedsImage = (themeId, index) => {
    if (APLUS_APPLICATION_IMAGE_PAGES[themeId]?.includes(index)) return false;
    const cfg = APLUS_NO_IMAGE_CONFIG[themeId];
    if (!cfg) return true;
    return cfg[index] !== false;
};

// Derived constant for max product images per theme
// B+ Product Limit = total bplus thumbnails - 2 (placeholders)
// A+ Product Limit = pages whose layout needs a product image
export const THEME_IMAGE_COUNT = Object.keys(THEME_CONFIG).reduce((acc, theme) => {
    const bPlusLimit = THEME_CONFIG[theme].bplus.length - 2;
    const noImageCfg = APLUS_NO_IMAGE_CONFIG[theme] || {};
    const pageCount = Math.max(
        Object.keys(noImageCfg).length,
        (APLUS_APPLICATION_IMAGE_PAGES[theme] || []).reduce((m, i) => Math.max(m, i + 1), 0)
    );
    let aPlusLimit = 0;
    for (let i = 0; i < pageCount; i++) {
        if (aplusPageNeedsImage(theme, i)) aPlusLimit++;
    }
    acc[theme] = { bplus: bPlusLimit, aplus: aPlusLimit };
    return acc;
}, {});

// Initial Form States
export const initialNewFormData = {
    brandName: '', category: '', subCategory: '', productType: '', briefDescription: '', keywords: '', 
    bannedKeywords:'', modelNumber: '', skuId: '', color: '', material: '', size: '', eanNumber: '',
    feature1: '', feature2: '', feature3: '', feature4: '', feature5: '', projectName: '',
    benefits: '', usage: '', instructions: '',
};

export const initialExistingInput = {
    asin: '',
    title: '',
    bullets: ['', '', '', '', ''], 
    description: ''
};